import { z } from "zod";
import { uuidSchema } from "../common/primitives.js";
/**
 * Yıkama ekranlarının SEÇİCİLERİ (Prompt 18 web takibi): el yıkama tableti (`WASH_ATTENDANT`) `shifts.read` /
 * `customers.read` taşımadığı için randevu ve iş emri pencerelerinde personel ve müşteri seçimi yıkama modülünün kendi
 * uçlarından yapılır. İzin `wash.operate` (istasyon kapsamlı), bayrak `WASH`.
 */
// ── Personel ───────────────────────────────────────────────────────────────────
export const washStaffQuerySchema = z.object({ stationId: uuidSchema });
/** İstasyonun ETKİN personeli (vardiya modülünün salt-okuma portu) — iş emri / check-in personel seçimi. */
export const washStaffOptionSchema = z.object({
    id: uuidSchema,
    code: z.string(),
    name: z.string().describe("Personelin adı (iş emrinde personel adı olarak da görünür)"),
});
export const washStaffListSchema = z.object({ items: z.array(washStaffOptionSchema) });
// ── Müşteri ────────────────────────────────────────────────────────────────────
export const WASH_CUSTOMER_SEARCH_MIN_LENGTH = 3;
export const WASH_CUSTOMER_SEARCH_LIMIT = 20;
export const washCustomerSearchQuerySchema = z.object({
    stationId: uuidSchema,
    q: z
        .string()
        .trim()
        .min(WASH_CUSTOMER_SEARCH_MIN_LENGTH, "En az 3 karakter yazın")
        .max(60)
        .describe("Ad (içinde geçen), müşteri kodu, telefon, sadakat kart no ya da plaka"),
});
/**
 * KVKK: yalnızca kimlik, kod, MASKELİ ad ve kart numarasının son 4 hanesi — telefon ve açık ad DÖNMEZ (görevli müşteriyi
 * seçer; iletişim bilgisi iş emrine ayrıca yazılır). Anonimleştirilmiş profil listelenmez.
 */
export const washCustomerOptionSchema = z.object({
    id: uuidSchema,
    code: z.string(),
    name: z.string().nullable().describe("KVKK: maskeli ad (A*** Y***); bireysel olmayan filo carisinde ünvan"),
    cardLast4: z.string().nullable().describe("Sadakat kart numarasının son 4 hanesi"),
});
export const washCustomerListSchema = z.object({ items: z.array(washCustomerOptionSchema) });
//# sourceMappingURL=pickers.js.map